<template>
  <div class="page" :class="pageSizeClass">
    <!-- 빈 페이지 -->
  </div>
</template>

<script>
export default {
  name: "article-blank-page",
  props: {
    group: {
      type: Object,
      required: false,
      default: () => {},
    },
    journal: {
      type: Object,
      required: false,
      default: () => {},
    },
    pageSize: {
      type: String,
      required: false,
      default: "A5",
    },
  },
  computed: {
    pageSizeClass() {
      return this.pageSize?.toLowerCase() || "a5";
    },
  },
};
</script>

<style lang="scss" scoped>
$background-color: #ffffff;

$a4-width: 794px;
$a4-height: 1122px;
$a5-width: 559px;
$a5-height: 794px;

.page {
  background-color: $background-color;
  position: relative;
  box-sizing: border-box;
  page-break-before: always;
  page-break-after: always;

  &.a4 {
    width: $a4-width;
    min-height: $a4-height;
  }

  &.a5 {
    width: $a5-width;
    min-height: $a5-height;
  }
}
</style>
